<template
  src="./index.html"
  lang="html"
/>
<style
  src="../../stylus/main.css"
  lang="css">
</style>
<script>

  import  { password, required, sameAs } from "../../vendors/vue-validate/validators";
  import prvInput from '../../components/prv-input/prv-input.vue'
  import prvDropdown from '../../components/prv-dropdown/prv-dropdown.vue'

  export default{
    components:{
      'prv-input': prvInput,
      'prv-dropdown': prvDropdown
    },
    data(){
      return {
        user:            null,
        password:        null,
        confirmPassword: null,
        token:           null,
        confirmCode:     null,
        resend:          null,
        status:{
          noToken:       true,
          expired:       false,
          forbidden:     false,
          badPassword:   false,
          success:       false
        }
      }
    },
    beforeRouteEnter(to, from, next) {

      next(vm => {

         if (!vm.$route.query.token) {
           vm.$router.push({
              path: '/'
           });
         }
      });
    },
    created() {
      this.validateToken();
    },
    methods: {
      validateToken() {

        this.token = this.$route.query.token;
        this.status.noToken = false;

        fetch('/api/v1/signup', {
          method: 'HEAD',
          headers: {
            'accept': '*/*',
            'X-Confirm': this.token
          },
          cors: 'no-cors',
          cache: 'no-cache',
        })
        .then(response => {

          switch(response.status) {

            case 204:
             this.confirmCode = response.headers.get('X-Confirm-Code');
            break;

            case 401:
              this.resend = response.headers.get('X-Resend-Payload');
              this.status.expired = true;
            break;

            case 403:
              this.status.forbidden = true;
            break;

          }
        })
        .catch(
          //TODO: MANAGE 500
        );
      },
      tryAgain() {

        fetch('/api/v1/signup', {
          method: 'HEAD',
          headers: {
            'accept': '*/*',
            'X-Resend': this.resend
          },
          cors:  'no-cors',
          cache: 'no-cache',
        })
        .then( () => location.replace(__ABOUT_HOST__))
        .catch(
          //TODO: Manage 500
        );
      },
      save() {

        fetch('/api/v1/signin', {
          method: 'PATCH',
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json',
            'X-Code': this.confirmCode,
          },
          cors: 'no-cors',
          cache: 'no-cache',
          body: JSON.stringify({d1: this.password})
        })
        .then(response => {

          switch(response.status) {

            case 204:
              this.status.success = true;
            break;

            case 422:
              this.status.badPassword = true;
            break;

            case 401:
              this.resend = response.headers.get('X-Resend-Payload');
              this.status.expired = true;
            break;
          }
        })
        .catch(
          //TODO: MANAGE 500
        );
      },
      redirec() {
        location.replace(__SIGN_IN_WEB_APP_HOST__)
      }
    },
    validations: {
      password: {
        required,
        password
      },
      confirmPassword: {
        sameAsPassword: sameAs('password')
      }
    }
  }
</script>
